import React from 'react';
import config from '../../../../config';

const UserList = ({ profiles, selectedUserId, onUserSelect, activeMeeting, isSelectionDisabled }) => {
  return (
    <div className="meeting-user-list mt-2">
      {profiles.map(user => (
        <div 
          key={user.user_id} 
          className={`user-list-item 
            ${selectedUserId === user.user_id ? 'selected' : ''} 
            ${isSelectionDisabled ? 'disabled' : ''}
          `}
          onClick={() => {
            if (!isSelectionDisabled) {
              onUserSelect(user);
            }
          }}
        >
          <div className="user-avatar">
            <img 
              src={`${config.baseURL}/uploads/profiles/${user.profile_image}` || '/images/no-image-found.webp'} 
              alt={user.first_name}
              onError={(e) => {
                e.target.src = '/images/no-image-found.webp';
              }}
            />
          </div>
          <div className="user-info">
            <div className="user-name">
              {user.first_name} {user.last_name}
              {activeMeeting?.user_2 === user.user_id && (
                <span className="meeting-badge"></span>
              )}
            </div>
            <div className="user-id">{user.profileId}</div>
          </div>
          {/* {isSelectionDisabled && (
            <div className="user-item-disabled-overlay">
              <span className="disabled-tooltip">Cannot select while meeting is active</span>
            </div>
          )} */}
        </div>
      ))}
    </div>
  );
};

export default UserList;